import React from 'react';

import { Container, Inner } from './styles';

interface FixedBottomPanelProps {
    isPressedAboveMenu?: boolean;
    forSpinner?: boolean;
    isRightAligned?: boolean;
    fullwidth?: boolean;
    isNewMainScreen?: boolean;
    insideStories?: boolean;
    buttonPosition?: string | { isScrolling?: boolean };
    isKeyboardOpened?: boolean;
    children?: React.ReactNode;
}

export const FixedBottomPanel: React.FC<FixedBottomPanelProps> = (props) => {
    return (
        <Container
            isPressedAboveMenu={props.isPressedAboveMenu}
            forSpinner={props.forSpinner}
            fullwidth={props.fullwidth}
            buttonPosition={props.buttonPosition}
            isNewMainScreen={props.isNewMainScreen}
            insideStories={props.insideStories}
        >
            <Inner
                isRightAligned={props.isRightAligned}
                fullwidth={props.fullwidth}
                isKeyboardOpened={props.isKeyboardOpened}
                isNewMainScreen={props.isNewMainScreen}
            >
                {props.children}
            </Inner>
        </Container>
    );
};
